import React from "react";
import {dataForSelect, selectValue} from "../../../helpers/Api";
import {Alert, Button, Col, Row} from "react-bootstrap";
import Select from "react-select";
import FlashMessage from "../../shared/FlashMessage";
import {UserContext} from "../../../context/UserContext";

const PlateIngredientForm = ({ plateIngredient, onSubmit, flash, plateIngredientIds }) => {
  const { units, ingredients } = React.useContext(UserContext);

  let hideIds = plateIngredientIds
  if (plateIngredient.ingredient)
    hideIds = hideIds.filter(id => id !== plateIngredient.ingredient.id)
  let ingredientsList = ingredients.filter(a => !hideIds.includes(String(a.id)))

  if (ingredients && ingredients.ingredientsForPlate)
    ingredientsList = [...ingredientsList, ...ingredients.ingredientsForPlate]

  return (
    <form onSubmit={onSubmit}>
      {ingredientsList.length === 0 &&
        <Alert variant='danger'>Reteta contine deja toate ingredientele</Alert>
      }
      <input type='hidden' name='id' id="id" defaultValue={plateIngredient.id} />
      <input type='hidden' name='plateId' id="plateId" defaultValue={plateIngredient.plateId} />
      <Row className='mb-3'>
        <Col>
          <label htmlFor='ingredient'>Ingredient</label>
          <Select name='ingredientId' id='ingredient' className="basic-single"
                  options={ingredients && dataForSelect(ingredientsList)}
                  defaultValue={plateIngredient.ingredient && selectValue(plateIngredient.ingredient)}
          />
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col>
          <label htmlFor='qty'>Cantitate</label>
          <input type="number" name='qty' id='qty' defaultValue={plateIngredient.qty}
                 className='form-control' />
        </Col>
        <Col>
          <label htmlFor='unit'>Unitate de masura</label>
          <Select name='unitId' id='unit' className="basic-single"
                  options={dataForSelect(units)}
                  defaultValue={plateIngredient.unit && selectValue(plateIngredient.unit)}
          />
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col>
          <label htmlFor='qty_info'>Aproximare cantitate (Ex: 1 cana)</label>
          <input type="text" name='qtyInfo' id='qty_info' className='form-control'
                 defaultValue={plateIngredient.qtyInfo} />
        </Col>
      </Row>
      <hr />
      <Row className='mb-3'>
        <FlashMessage flash={flash} buttons={
          <Button type='submit' className='float-end'>Salveaza</Button>} />
      </Row>
    </form>
  )
};

export default PlateIngredientForm;
